import webBiLogger from '@wix/web-bi-logger';

export const biLogger = webBiLogger
  .factory({ endpoint: 'new-releases' })
  .updateDefaults({
    src: 123,
  })
  .logger();

